import type { GetBillingReportResponse } from '@fourthwall/services/dist/BillingApiClient'
import { downloadCsvFile } from '@fourthwall/utils/dist/downloadCsvFile'
import { useCurrentShopQuery } from '@modules/Dashboard/hooks/useCurrentShopQuery'
import { useGetBillingReportMutation } from '@modules/Dashboard/pages/Settings/pages/Billing/pages/Transactions/queries/useGetBillingReportMutation'

import { useShopTime } from '../../../../../../../../Timezone/providers/ShopTimeProvider'
import { transactionTypeTexts } from '../consts'

const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSSSSZZ'

export const useBillingReport = () => {
  const { currentShopQuery } = useCurrentShopQuery()
  const { billingRecordMutation } = useGetBillingReportMutation()
  const { formatInShopTime, timezoneAbbreviation } = useShopTime()

  const dateKey = `transaction_at (${timezoneAbbreviation})`

  const mapTransactionTypeTexts = (data: GetBillingReportResponse) => {
    return data.billing.map((item) => ({
      ...item,
      transaction_type: (transactionTypeTexts as any)[item.transaction_type!!],
      [dateKey]: item.transaction_at ? formatInShopTime(item.transaction_at, DATE_FORMAT) : '',
    }))
  }

  const download = () => {
    if (!currentShopQuery.data) return

    billingRecordMutation.mutate([], {
      onSuccess: (data) => {
        downloadCsvFile(
          mapTransactionTypeTexts(data),
          `${currentShopQuery.data.name}-transactions-report`,
          [
            'id',
            'original_id',
            dateKey,
            'transaction_type',
            'sub_type',
            'order.order.friendly_id',
            'order.order.status',
            'profit',
            'income',
            'cost',
            'currency',
            'products.price',
            'products.cost',
            'shipping_cost',
            'shipping_price',
            'tax',
            'donation',
            'discount',
            'fulfillment_cost',
            'payment_fee',
            'refund_value',
            'order.sample_credit_used',
            'order.thank_you_card_fee',
          ],
        )
      },
    })
  }

  return {
    billingReport: {
      download,
      isLoading: billingRecordMutation.isLoading,
    },
  }
}
